import { Image, Modal, ActionIcon } from '@mantine/core';
import { useState } from 'react';
import { pb } from '../lib/pocketbase';
import { IconX } from '@tabler/icons-react';
import { InventoryRecord } from '../types/pocketbase-types';

export default function ImageCell({ record }: { record: InventoryRecord }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const imageUrl = record.image ? pb.files.getURL(record, record.image) : '';

  if (!imageUrl) return null;

  return (
    <>
      <Image
        src={imageUrl}
        alt={record.product_name}
        width={40}
        height={40}
        radius="sm"
        fit="contain"
        style={{ cursor: 'pointer' }}
        onClick={() => setIsModalOpen(true)}
      />
      <ImageModal
        imageUrl={imageUrl}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}

interface ImageModalProps {
  imageUrl: string;
  isOpen: boolean;
  onClose: () => void;
}

function ImageModal({ imageUrl, isOpen, onClose }: ImageModalProps) {
  return (
    <Modal
      centered={true}
      opened={isOpen}
      onClose={onClose}
      size="xl"
      padding={0}
      withCloseButton={false}
      styles={{
        body: {
          padding: 0,
        },
        content: {
          backgroundColor: 'transparent',
        },
      }}
    >
      <ActionIcon
        variant="filled"
        color="dark"
        size="xl"
        radius="xl"
        onClick={onClose}
        style={{
          position: 'absolute',
          top: 10,
          right: 10,
          zIndex: 1000,
        }}
      >
        <IconX size={18} />
      </ActionIcon>
      <Image
        src={imageUrl}
        alt="תמונת מוצר"
        fit="contain"
        style={{ maxHeight: '90vh' }}
      />
    </Modal>
  );
}
